import { h, createContext } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import CartService, { CART_EVENTS } from './cart-service';

const Context = createContext();

const CartContext = ({ children, data }) => {
  const [cartState, setCartState] = useState(CartService.cart);
  const [loading, setLoading] = useState(CartService.loading);

  useEffect(() => {
    const cartCountEls = document.querySelectorAll('[data-cart-count]');

    cartCountEls.forEach((cartCountEl) => {
      cartCountEl.setAttribute('data-cart-count', cartState.item_count);
      if (cartState.item_count > 0) {
        // eslint-disable-next-line no-param-reassign
        cartCountEl.textContent = cartState.item_count;
        cartCountEl.classList.add('bg-[#AA4630]')
      } else {
        // eslint-disable-next-line no-param-reassign
        cartCountEl.textContent = null;
        cartCountEl.classList.remove('bg-[#AA4630]')
      }
      return null;
    });
  }, [cartState.item_count]);

  useEffect(() => {
    const listener = (event) => {
      setLoading(CartService.loading);
      setCartState(CartService.cart);
      if (event === CART_EVENTS.UPDATE) {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
    }
    CartService.addListener(listener);
    setCartState(CartService.cart);
    return () => {
      CartService.removeListener(listener);
    }
  }, [])

  // Handle bfcache restore to refresh cart state on back/forward navigation
  useEffect(() => {
    const handlePageShow = (event) => {
      // When page is restored from bfcache (Safari back button), refresh cart
      if (event?.persisted) {
        CartService.get(true);
      }
    };
    
    window.addEventListener('pageshow', handlePageShow);
    
    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [])

  /**
   * Wrapper for cart API to make interactions more simple
   */
  const cart = {
    add: (...params) => CartService.add(...params),
    remove: (...params) => CartService.remove(...params),
    update: (...params) => CartService.update(...params),
    updateAttributes: (...params) => CartService.updateAttributes(...params),
    state: cartState,
  };

  return (
    <Context.Provider value={{ cart, cartLoading: loading, data }}>
      {children}
    </Context.Provider>
  );
};

export const withCartContext = (Rendered) => (props) =>
(
  <Context.Consumer>
    {(value) => <Rendered {...props} {...value} />}
  </Context.Consumer>
);

export default CartContext;
